export default "__VITE_ASSET__BZjyPK7H__"